import { el, mount, setChildren, text } from "redom";

import List from "list.js";
import sanitizeHtml from "sanitize-html";

const elements = {
	listContainer: document.querySelector(".products-grid .products-grid-list"),
	filterButtons: document.querySelector(".products-grid .data-filters"),
	filterSelect: document.querySelector(".products-grid .products-filter"),
	sortSelect: document.querySelector(".products-grid select.products-sort"),
	showMoreButton: document.querySelector(".products-grid button.show-more"),
	showMoreSpinner: document.querySelector(
		".products-grid button.show-more .spinner"
	),
};

let list = null;

if (elements.listContainer) {
	list = new List(elements.listContainer, {
		valueNames: ["product-price", "product-name"],
	});
}

var page = 2;

function updateFilterOptions({ products }) {
	const filterOptions = Array.from(
		elements.filterButtons.querySelectorAll("button")
	).map((option) => {
		return option.getAttribute("data-filter");
	});

	products?.forEach(({ categories }) => {
		categories?.forEach((category) => {
			if (!filterOptions?.includes(category)) {
				const button = el("button", {
					"data-filter": sanitizeHtml(category),
					textContent: sanitizeHtml(category.replace("-", " ")),
				});
				const option = el("option", {
					value: sanitizeHtml(category),
					textContent: sanitizeHtml(category.replace("-", " ")),
				});
				mount(elements.filterButtons, button);
				mount(elements.filterSelect, option);
			}
		});
	});
}

function hideShowMoreButton() {
	elements.showMoreButton.disabled = true;
	elements.showMoreButton.style.display = "none";
}

function addListItems({ products, currency_symbol }) {
	products.forEach(
		({
			image,
			name,
			permalink,
			price,
			colourways = null,
			sizes = null,
			categories = null,
			in_stock,
		}) => {
			// 1. Set Parent Product
			const product = el("a.product-card", {
				href: sanitizeHtml(permalink),
				"data-categories": sanitizeHtml(categories?.join(" ")),
				"data-in-stock": in_stock ? "true" : "false",
			});

			// 2. Set Product Image
			const productImage = el("div.product-image-wrapper", {
				innerHTML: sanitizeHtml(image, {
					allowedTags: ["img"],
					allowedAttributes: {
						img: [
							"src",
							"width",
							"height",
							"class",
							"alt",
							"decoding",
							"srcset",
							"sizes",
							"data-has-transparency",
							"data-dominant-colour",
							"style",
						],
					},
				}),
			});

			// 3. Set Product Name and Price
			const infoWrapper = el("div.product-info");
			const namePrice = el("div.product-name-price");
			const productName = el("h2.product-name", {
				textContent: sanitizeHtml(name),
			});
			const productPrice = el("span.product-price", {
				textContent: in_stock
					? sanitizeHtml(currency_symbol) + sanitizeHtml(price)
					: "Out of stock",
			});
			setChildren(namePrice, [productName, productPrice]);

			// 4. Set Product Attributes - e.g. colour and size
			const attributes = el("div.product-attributes");
			if (sizes || colourways) {
				const sizeColourWayschildren = [];
				if (sizes) {
					const sizeWrapper = el("div.product-size");
					const sizeChildren = [
						el("span", {
							textContent: "Size",
						}),
					];
					Object.values(sizes).forEach((size, index) => {
						const sizeEl = el("span");
						sizeEl.textContent = `${sanitizeHtml(size)}${
							index + 1 !== Object.values(sizes).length ? "," : ""
						}`;
						sizeChildren.push(sizeEl);
					});
					setChildren(sizeWrapper, sizeChildren);
					sizeColourWayschildren.push(sizeWrapper);
				}

				if (colourways) {
					const colourwayWrapper = el("div.product-colourways");
					const colourwayChildren = [];
					colourways.forEach((colourway) => {
						const colourwayEl = el("span.product-colourway", {
							style: `background:${sanitizeHtml(colourway)};`,
						});
						colourwayChildren.push(colourwayEl);
					});
					setChildren(colourwayWrapper, colourwayChildren);
					sizeColourWayschildren.push(colourwayWrapper);
				}

				setChildren(attributes, sizeColourWayschildren);
			}

			setChildren(infoWrapper, [namePrice, attributes]);
			setChildren(product, [productImage, infoWrapper]);

			mount(elements.listContainer.querySelector(".grid"), product);
		}
	);
}

function fetchMoreProducts() {
	if (elements.showMoreButton.textContent.toUpperCase() !== "SHOW MORE") {
		elements.showMoreButton.textContent = "Show More";
	}
	elements.showMoreSpinner.style.display = "flex";
	elements.showMoreButton.disabled = true;
	let url = "/wp-admin/admin-ajax.php";
	let data = {
		action: "load_more_products",
		page: page,
		nonce: tokens.nonce,
	};
	fetch(url + "?" + new URLSearchParams(data))
		.then((response) => {
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			return response.json();
		})
		.then((data) => {
			page++;
			if (data.products) {
				list.filter();
				addListItems(data);
				updateFilterOptions(data);
				list.reIndex();
				elements.showMoreSpinner.style.display = "none";
			}
			if (!data?.more_posts) {
				hideShowMoreButton();
				return;
			}
			elements.showMoreButton.disabled = false;
		})
		.catch((error) => {
			// TODO - ADD IN SUFFICIENT ERROR MESSAGING
			elements.showMoreButton.disabled = false;
			elements.showMoreButton.textContent = "Something went wrong - try again!";
		});
}

function filterList(filterTerm) {
	console.log(list);
	list?.filter((item) => {
		if (
			item.elm.getAttribute("data-categories").includes(filterTerm) ||
			filterTerm === "all"
		) {
			return item;
		}
	});
}

elements.filterButtons?.addEventListener("click", (e) => {
	if (e.target && e.target.tagName === "BUTTON") {
		const filter = e.target.getAttribute("data-filter");
		Array.from(elements.filterButtons.querySelectorAll("button")).forEach(
			(button) => {
				button.classList.toggle(
					"active-filter",
					button.getAttribute("data-filter") === filter
				);
			}
		);
		filterList(filter);
		/**
		 * Sync with our select
		 */
		elements.filterSelect.value = filter;
	}
});

elements.sortSelect &&
	elements.sortSelect?.addEventListener("change", (e) => {
		const sortMode = e.target.value.split("_");
		const sortType = sanitizeHtml(sortMode[0]);
		const sortDirection = sanitizeHtml(sortMode[1]);
		list.sort(sortType, {
			order: sortDirection,
		});
	});

elements.filterSelect &&
	elements.filterSelect.addEventListener("change", (e) => {
		filterList(e.target.value);
		/**
		 * Sync with our button based filters.
		 */
		Array.from(elements.filterButtons.querySelectorAll(`button`)).map(
			(button) => {
				button.classList.toggle(
					"active-filter",
					button.getAttribute("data-filter") === e.target.value
				);
			}
		);
	});

elements.showMoreButton &&
	elements.showMoreButton.addEventListener("click", fetchMoreProducts);
